import { useEffect, useState } from "react";
import { Button, SvgIcon } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import "./style.scss";
import { ReactComponent as RefreshIcon } from "../../../assets/refresh.icon.svg";
import { ReactComponent as CheckboxIcon } from "../../../assets/checkbox.icon.svg";
import { ReactComponent as CheckboxCheckedIcon } from "../../../assets/checkbox-checked.icon.svg";
import { ModalTemplate } from "../../modal-template/modal-template.comp";

export interface ReprocessOptions {
    resetVideoTimeline: boolean;
    resetVideoTranscript: boolean;
}

export const ReprocessConfirmationModal = ({
    open,
    handleClose,
    handleAction
}: {
    open: boolean;
    handleClose: () => void;
    handleAction: (options: ReprocessOptions) => void;
}) => {
    const [resetVideoTimeline, setResetVideoTimeline] = useState(false);
    const [resetVideoTranscript, setResetVideoTranscript] = useState(false);

    useEffect(() => {
        if (open) {
            setResetVideoTimeline(false);
            setResetVideoTranscript(false);
        }
    }, [open]);

    const onConfirm = () => {
        handleAction({ resetVideoTimeline, resetVideoTranscript });
    };

    return (
        <ModalTemplate open={open} width={520} handleClose={handleClose} ariaLabel="Reprocess">
            <div className="reprocess-confirmation-view">
                <div className="reprocess-confirmation-title">
                    <SvgIcon
                        className="reprocess-confirmation-title__icon"
                        component={RefreshIcon}
                        inheritViewBox
                    />
                    <span className="reprocess-confirmation-title__text">Reprocess</span>
                </div>
                <div className="reprocess-confirmation-description">
                    <span className="reprocess-confirmation-description__text">
                        Optionally reset video state on affected items before reprocessing.
                    </span>
                </div>
                <div className="reprocess-confirmation-options">
                    <label className="reprocess-confirmation-option">
                        <Checkbox
                            checked={resetVideoTimeline}
                            onChange={() => setResetVideoTimeline(v => !v)}
                            icon={<CheckboxIcon />}
                            checkedIcon={<CheckboxCheckedIcon />}
                        />
                        <span className="reprocess-confirmation-option__text">Video Timeline</span>
                    </label>
                    <label className="reprocess-confirmation-option">
                        <Checkbox
                            checked={resetVideoTranscript}
                            onChange={() => setResetVideoTranscript(v => !v)}
                            icon={<CheckboxIcon />}
                            checkedIcon={<CheckboxCheckedIcon />}
                        />
                        <span className="reprocess-confirmation-option__text">
                            Video Transcript
                        </span>
                    </label>
                </div>
                <div className="reprocess-confirmation-action">
                    <Button className="thirt-button" variant="text" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        className="primary-button button-left-margin"
                        variant="text"
                        onClick={onConfirm}
                    >
                        Reprocess
                    </Button>
                </div>
            </div>
        </ModalTemplate>
    );
};
